import React, { useEffect, useState } from 'react';
import Marquee from 'react-fast-marquee';
import api from '../../lib/api';

const FALLBACK = [
  '🏉 Springboks vs All Blacks — Springboks 1.85 / Draw 22.00 / All Blacks 2.10',
  '⚽ Orlando Pirates vs Kaizer Chiefs — Pirates 2.05 / Draw 3.20 / Chiefs 3.45',
  '🏉 Sharks vs Bulls — Sharks 1.75 / Bulls 2.30',
  '⚽ Mamelodi Sundowns vs SuperSport United — Sundowns 1.55 / Draw 3.80 / SSU 5.50',
  '🏏 Proteas vs India — Proteas 2.40 / India 1.65',
  '🥊 Heavyweight Bout: Ngannou 1.90 / Fury 1.85',
  '🏉 Stormers vs Lions — Stormers 1.60 / Lions 2.75',
  '⚽ Chelsea vs Arsenal — Chelsea 2.90 / Draw 3.30 / Arsenal 2.35',
  '⭐ Powered by BetXchange ⭐',
];

export default function Ticker() {
  const [odds, setOdds] = useState(FALLBACK);

  useEffect(() => {
    let mounted = true;
    api
      .get('/odds')
      .then((r) => {
        if (mounted && Array.isArray(r.data?.odds) && r.data.odds.length) setOdds(r.data.odds);
      })
      .catch(() => {});
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div
      data-testid="odds-ticker"
      className="fixed top-0 left-0 right-0 z-50 h-10 bg-black border-b border-[#D4AF37]/30 flex items-center overflow-hidden"
    >
      <Marquee gradient={false} speed={55} pauseOnHover className="h-full">
        {odds.map((o, i) => (
          <span
            key={i}
            className="inline-flex items-center text-[#D4AF37] text-sm font-medium tracking-wide px-8"
          >
            {o}
            <span className="mx-6 text-[#D4AF37]/40">•</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
